import { configureStore } from '@reduxjs/toolkit';

import dashboardReducer from './slices/dashboardSlice';
import orgSlice from './slices/orgSlice';
import rbacReducer from './slices/rbacSlice';

const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    orgSlice: orgSlice,
    rbac: rbacReducer,
  },
});

export default store;
